import './Footer.scss'

export function Footer() {
    return (
        <div className="footer">
            Copyright © 2022. Designed by Mateusz Binięda
        </div>
    )
}
